"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMarketingConsent = void 0;
const BrandFormParameterType_1 = require("../../enums/brandFormParameter/BrandFormParameterType");
const defaultMarketingConsent = (organizationId) => {
    return {
        organizationId,
        internalName: 'Marketing consent',
        type: BrandFormParameterType_1.BrandFormParameterType.CHECKBOX,
        isMandatory: false,
        placeholder: '',
        values: 'I consent to receiving email updates and offers.',
    };
};
exports.defaultMarketingConsent = defaultMarketingConsent;
